// Nâng ô soạn tin lên TRÊN bàn phím ảo (mobile / WebView Capacitor).
//
// Vấn đề: khung chat mobile là position:fixed; bottom:0; cao 100dvh, ô soạn tin nằm sát đáy.
// Mặc định trình duyệt/WebView chỉ co "visual viewport" khi bàn phím ảo mở (resizes-visual) chứ
// KHÔNG co layout, nên ô soạn bị bàn phím CHE -> "không xem được tin đang soạn". Rõ nhất trên máy
// màn gần vuông như Galaxy Z Fold (mở ra) vì bàn phím ăn phần lớn chiều cao.
//
// Hai lớp xử lý, LOẠI TRỪ NHAU tự nhiên (không nâng gấp đôi):
//   1) index.html đặt interactive-widget=resizes-content -> WebView mới tự CO layout theo bàn phím,
//      khung chat co lại, ô soạn nổi lên. Khi đó window.innerHeight cũng co nên overlap ≈ 0.
//   2) Module này (dự phòng cho WebView CŨ không hiểu (1)): visualViewport vẫn báo chiều cao thật,
//      tính phần đáy bị bàn phím che -> đặt biến --kb-inset + class html.kb-open để CSS nâng ô soạn.
export function setupKeyboardInset() {
  if (typeof window === 'undefined') return;
  const vv = window.visualViewport;
  const root = document.documentElement;
  if (!vv || !root) return; // trình duyệt quá cũ -> bỏ qua, không gây hại

  let raf = 0;
  const apply = () => {
    raf = 0;
    // overlap = phần đáy bị bàn phím che = cao layout - (cao nhìn thấy + phần đã cuộn/pan lên).
    // Khi (1) đã co layout theo bàn phím thì innerHeight ~ vv.height -> overlap ~ 0 -> KHÔNG cộng thêm.
    const overlap = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
    root.style.setProperty('--kb-inset', overlap + 'px');
    root.classList.toggle('kb-open', overlap > 80); // >80px mới coi là bàn phím (lọc thanh công cụ nhỏ)
  };
  const schedule = () => { if (!raf) raf = requestAnimationFrame(apply); };

  vv.addEventListener('resize', schedule);
  vv.addEventListener('scroll', schedule);
  apply();
}

// Đăng ký callback chạy KHI BÀN PHÍM ẢO VỪA MỞ (visual viewport co lại ≥ ngưỡng). Trả hàm huỷ.
// Dùng cho khung chat: khi bật bàn phím, kéo tin mới nhất lên trên ô soạn (giống Zalo/Messenger),
// vì khung co lại -> tin cuối dễ bị bàn phím/ô soạn che. Không có visualViewport -> no-op an toàn.
export function onKeyboardOpen(cb) {
  if (typeof window === 'undefined') return () => {};
  const vv = window.visualViewport;
  if (!vv) return () => {};
  let lastH = vv.height;
  const on = () => {
    const shrank = vv.height < lastH - 60; // co ≥60px = coi như bàn phím vừa hiện
    lastH = vv.height;
    if (shrank) cb();
  };
  vv.addEventListener('resize', on);
  return () => vv.removeEventListener('resize', on);
}
